/* Winterfeldt Landing — Hero-Crossfade + Produkt-Karussell */
(function () {
  'use strict';

  /* Jede WF-Section rendert denselben Asset-Snippet. Externe Scripts können
     dadurch mehrfach im HTML stehen. Dieser Guard stellt sicher, dass die
     Logik trotzdem nur einmal initialisiert wird. */
  if (window.__wfLandingLoaded) return;
  window.__wfLandingLoaded = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Hero: zwei Bilder, 5s sichtbar + 1s Crossfade ---- */
  function initHero(root) {
    var imgs = root.querySelectorAll('[data-wf-hero-img]');
    var cta = root.querySelector('[data-wf-hero-cta]');
    if (imgs.length < 2) return;
    var labels = cta ? (cta.getAttribute('data-labels') || '').split('|') : [];
    var i = 0;
    function paint() {
      imgs.forEach(function (el, n) { el.setAttribute('data-active', n === i ? 'true' : 'false'); });
      if (cta && labels.length === 2) {
        cta.firstChild.nodeValue = labels[i] + ' ';
        cta.style.background = i === 1 ? '#3a2116' : 'rgba(255,250,240,.5)';
        cta.style.color = i === 1 ? '#fffaf0' : '#3a2116';
      }
    }
    paint();
    if (reduce) return;
    setInterval(function () { i = (i + 1) % 2; paint(); }, 6000);
  }

  /* ---- Neu im Sortiment: rotierendes Fenster über die Produktliste ----
     Zeigt je nach Breite 4 / 2 / 1 Karten. Pfeile blättern um eine Karte.
     data-wf-autoplay="5" dreht alle 5 Sekunden automatisch eine Karte
     weiter; Pause, solange Maus oder Tastatur-Fokus auf dem Bereich liegt,
     der Tab im Hintergrund ist oder "weniger Bewegung" eingestellt ist.
     Das Event "wf:refresh" (z. B. nach dem Nachladen der neuesten
     Produkte) zeichnet die Karten neu.
     Handy (unter 640 px): Wischleiste statt Fenster. Alle Karten liegen
     nebeneinander, die naechste schaut am Rand hervor, man wischt mit dem
     Finger (Klasse wf-wisch, Aussehen in assets/wf-mobil.css). Die Pfeile
     scrollen die Leiste um eine Karte, am Ende geht es wieder zum Anfang.
     Kein automatisches Weiterdrehen in diesem Modus. */
  function initCarousel(root) {
    var grid = root.querySelector('[data-wf-grid]');
    if (!grid || root.__wfInit) return;
    root.__wfInit = true;
    var offset = 0;
    var timer = null;
    var paused = false;
    var auto = parseInt(root.getAttribute('data-wf-autoplay') || '0', 10) || 0;

    function cards() {
      return Array.prototype.filter.call(grid.children, function (c) { return c.tagName === 'ARTICLE'; });
    }
    function perView() {
      var w = window.innerWidth;
      return w >= 1180 ? 4 : (w < 640 ? 1 : 2);
    }
    function wisch() {
      return window.innerWidth < 640;
    }
    function wischen(richtung) {
      var list = cards();
      if (!list.length) return;
      var gs = getComputedStyle(grid);
      var schritt = list[0].getBoundingClientRect().width + (parseFloat(gs.columnGap) || 0);
      var ende = grid.scrollWidth - grid.clientWidth;
      var art = reduce ? 'auto' : 'smooth';
      if (richtung > 0 && grid.scrollLeft >= ende - 4) grid.scrollTo({ left: 0, behavior: art });
      else if (richtung < 0 && grid.scrollLeft <= 4) grid.scrollTo({ left: ende, behavior: art });
      else grid.scrollBy({ left: richtung * schritt, behavior: art });
    }
    function paint(animate) {
      var list = cards();
      if (!list.length) return;
      var nav = root.querySelector('[data-wf-nav]');
      if (wisch()) {
        grid.classList.add('wf-wisch');
        list.forEach(function (c) { c.style.display = ''; c.style.animation = ''; });
        if (nav) nav.style.display = list.length > 1 ? '' : 'none';
        return;
      }
      grid.classList.remove('wf-wisch');
      var n = Math.min(perView(), list.length);
      list.forEach(function (c) { c.style.display = 'none'; c.style.animation = ''; });
      for (var k = 0; k < n; k++) {
        var c = list[((offset + k) % list.length + list.length) % list.length];
        c.style.display = '';
        if (animate && !reduce) {
          c.style.animation = 'none';
          void c.offsetWidth;
          c.style.animation = 'wf-pop 680ms cubic-bezier(.22,1,.36,1) both';
          c.style.animationDelay = (k * 110) + 'ms';
        }
      }
      if (nav) nav.style.display = list.length > n ? '' : 'none';
    }
    function tick() {
      if (paused || document.hidden || wisch()) return;
      var list = cards();
      if (list.length <= perView()) return;
      offset += 1;
      paint(true);
    }
    function restart() {
      if (timer) clearInterval(timer);
      timer = null;
      if (!auto || reduce) return;
      timer = setInterval(tick, auto * 1000);
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wf-step]');
      if (!b) return;
      if (wisch()) { wischen(parseInt(b.getAttribute('data-wf-step'), 10)); return; }
      offset += parseInt(b.getAttribute('data-wf-step'), 10);
      paint(true);
      restart();
    });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    root.addEventListener('wf:refresh', function () { offset = 0; grid.scrollLeft = 0; paint(false); restart(); });
    window.addEventListener('resize', function () { paint(false); });
    paint(false);
    restart();
  }

  function boot() {
    document.querySelectorAll('[data-wf-hero]').forEach(initHero);
    document.querySelectorAll('[data-wf-new]').forEach(initCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Shopify Theme-Editor: Sections werden neu gerendert */
  document.addEventListener('shopify:section:load', boot);
})();
